import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import back from "assets/icons/back-arrow.svg";
import edit from "assets/icons/edit.svg";
import close from "assets/icons/close.svg";
import AccordionItem from "../components/Accordion";
import { useEffect, useState } from "react";
import RadioButton from "../components/RadioButton";
import UseModal from "../components/useModal";
import { updateUserMedicalInfo } from "js/redux/actions/user";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { toast, ToastContainer } from "react-toastify";

function EditProfile({ userData, updateUserMedicalInfo, t }) {
  const [personalInfoIsOpen, setPersonalInfoIsOpen] = useState(true);
  const [medicalInfoIsOpen, setMedicalInfoIsOpen] = useState(true);

  const [userDetails, setUserDetails] = useState();

  const navigate = useNavigate();

  const [Modal, openModal, closeModal] = UseModal();

  useEffect(() => {
    if (userData) {
      if (!userData.medical_info) {
        const data = {
          ...userData,
          medical_info: {
            has_allergies: 0,
            allergies: "",
            has_medication: 0,
            medication: "",
          },
        };
        setUserDetails(data);
      } else {
        setUserDetails(userData);
      }
    }
  }, [userData]);

  function isDeepChanged(obj1, obj2) {
    return JSON.stringify(obj1) !== JSON.stringify(obj2);
  }

  const saveMedicalInfo = async () => {
    const updatedUserDetails = {
      allergies: userDetails.medical_info.allergies,
      has_allergies: userDetails.medical_info.has_allergies,
      has_medication: userDetails.medical_info.has_medication,
      medication: userDetails.medical_info.medication,
      medical_info_id: userDetails.medical_info.uuid,
      name: userDetails.firstname + " " + userDetails.lastname,
      gender: userDetails.gender,
      date_of_birth: userDetails.date_of_birth,
      firstname: userDetails.firstname,
      lastname: userDetails.lastname,
    };

    const result = await updateUserMedicalInfo(updatedUserDetails);
    if (result) {
      toast.success("Profile updated successfully", {
        onClose: () => navigate("/dashboard/profile"),
        autoClose: 2000,
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal>
        <div className="unsaved-modal-container">
          <div className="unsaved-modal-header">
            <span className="unsaved-modal-title">
              {t("profile.unsaved_changes")}
            </span>
            <img
              src={close}
              alt="close"
              className="close-btn"
              onClick={() => {
                closeModal();
              }}
            />
          </div>
          <span className="unsaved-modal-subtitle">
            {t("profile.unsaved_changes_tagline")}
          </span>
          <div className="unsaved-modal-buttons-container">
            <button
              className="unsaved-save-button"
              onClick={() => saveMedicalInfo()}
            >
              {t("profile.save_and_exit")}
            </button>
            <button
              className="unsaved-cancel-button"
              onClick={() => {
                closeModal();
                navigate("/dashboard/profile");
              }}
            >
              {t("profile.exit")}
            </button>
          </div>
        </div>
      </Modal>
      {userDetails && (
        <div className="edit-profile-container">
          <div className="heading-container">
            <div className="back-container">
              <img
                src={back}
                alt="back"
                className="back-icon"
                onClick={() => {
                  if (isDeepChanged(userData, userDetails)) {
                    openModal();
                  } else {
                    navigate("/dashboard/profile");
                  }
                }}
              />
              <span className="profile-heading">Edit Profile</span>
            </div>
            <div className="btn-container">
              <span className="last-seen-text">
                {t("profile.last_changed")} :{" "}
                {moment
                  .tz(
                    userDetails.medical_info.updated_at,
                    "YYYY-MM-DD HH:mm:ss",
                    "Europe/Oslo"
                  )

                  .tz("Europe/Oslo")
                  .locale("no")
                  .format("D MMMM YYYY h:mmA")}
              </span>
            </div>
          </div>
          <div className="profile-details-container">
            <AccordionItem
              isOpen={personalInfoIsOpen}
              className="profile-details-accordion"
              onClick={() => setPersonalInfoIsOpen(!personalInfoIsOpen)}
              title={
                <span className="personal-details-title">
                  {t("profile.personal_details")}
                </span>
              }
            >
              <div className="patient-details-wrapper">
                <div className="patient-details-grid">
                  <div className="patient-detail">
                    <label className="patient-label">
                      {t("profile.first_name")}
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="patient-value"
                      value={userDetails.firstname}
                      onChange={(e) => {
                        setUserDetails({
                          ...userDetails,
                          firstname: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="patient-detail">
                    <label className="patient-label">
                      {t("profile.last_name")}
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="patient-value"
                      value={userDetails.lastname}
                      onChange={(e) => {
                        setUserDetails({
                          ...userDetails,
                          lastname: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="patient-details-grid">
                  <div className="patient-detail">
                    <label className="patient-label">
                      {t("profile.date_of_birth")}
                    </label>
                    <input
                      type="text"
                      name="dob"
                      className="patient-value"
                      value={userDetails.date_of_birth}
                      onChange={(e) => {
                        setUserDetails({
                          ...userDetails,
                          date_of_birth: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="patient-detail">
                    <label className="patient-label">
                      {t("profile.gender")}
                    </label>
                    <input
                      type="text"
                      name="gender"
                      className="patient-value capitalize-first-letter"
                      value={userDetails.gender}
                      onChange={(e) => {
                        setUserDetails({
                          ...userDetails,
                          gender: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="patient-details-grid">
                  <div className="patient-detail">
                    <label className="patient-label">
                      {t("profile.email")}
                    </label>
                    <input
                      type="text"
                      name="email"
                      className="patient-value"
                      value={userDetails.email ?? "-----"}
                      onChange={(e) => {
                        setUserDetails({
                          ...userDetails,
                          email: e.target.value,
                        });
                      }}
                      disabled
                    />
                  </div>
                  <div className="patient-detail">
                    <label className="patient-label">
                      {t("profile.phone_number")}r
                    </label>
                    <input
                      type="text"
                      name="phone-number"
                      className="patient-value"
                      value={userDetails.phonenumber}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </AccordionItem>
          </div>
          <div className="profile-details-container">
            <AccordionItem
              isOpen={medicalInfoIsOpen}
              className="profile-details-accordion med-history-accordion"
              onClick={() => setMedicalInfoIsOpen(!medicalInfoIsOpen)}
              title={
                <span className="personal-details-title">
                  {t("profile.medical_history")}
                </span>
              }
            >
              <div className="patient-detail">
                <label className="patient-label">
                  {t("profile.have_allergies")}
                </label>
                <div className="allergy-div">
                  <RadioButton
                    name="Yes"
                    value="Yes"
                    label="Yes"
                    checked={
                      userDetails.medical_info &&
                      userDetails.medical_info.has_allergies === 1
                    }
                    onChange={() => {
                      setUserDetails({
                        ...userDetails,
                        medical_info: {
                          ...userDetails.medical_info,
                          has_allergies: 1,
                        },
                      });
                      //setHasAllergies(true);
                    }}
                  />

                  <RadioButton
                    name="No"
                    value="No"
                    label="No"
                    checked={
                      userDetails.medical_info &&
                      userDetails.medical_info.has_allergies === 0
                    }
                    onChange={() => {
                      setUserDetails({
                        ...userDetails,
                        medical_info: {
                          ...userDetails.medical_info,
                          has_allergies: 0,
                        },
                      });
                      //setHasAllergies(false);
                    }}
                  />
                </div>
              </div>

              {userDetails.medical_info &&
                userDetails.medical_info.has_allergies === 1 && (
                  <textarea
                    type="text"
                    name="allergies-text"
                    className="allergies-text"
                    placeholder="Please specify your allergies"
                    rows={5}
                    value={
                      userDetails.medical_info
                        ? userDetails.medical_info.allergies
                        : ""
                    }
                    onChange={(e) => {
                      setUserDetails({
                        ...userDetails,
                        medical_info: {
                          ...userDetails.medical_info,
                          allergies: e.target.value,
                        },
                      });
                      //setAllergies(e.target.value);
                    }}
                  />
                )}
              <div className="patient-detail">
                <label className="patient-label">
                  {t("profile.have_medicines")}
                </label>
                <div className="allergy-div">
                  <RadioButton
                    name="medication-yes"
                    value="Yes"
                    label="Yes"
                    checked={
                      userDetails.medical_info &&
                      userDetails.medical_info.has_medication === 1
                    }
                    onChange={() => {
                      setUserDetails({
                        ...userDetails,
                        medical_info: {
                          ...userDetails.medical_info,
                          has_medication: 1,
                        },
                      });
                      //setHasMedication(true);
                    }}
                  />

                  <RadioButton
                    name="medication-no"
                    value="No"
                    label="No"
                    checked={
                      userDetails.medical_info &&
                      userDetails.medical_info.has_medication === 0
                    }
                    onChange={() => {
                      setUserDetails({
                        ...userDetails,
                        medical_info: {
                          ...userDetails.medical_info,
                          has_medication: 0,
                        },
                      });
                      //setHasMedication(false);
                    }}
                  />
                </div>
              </div>
              {userDetails.medical_info &&
                userDetails.medical_info.has_medication === 1 && (
                  <textarea
                    type="text"
                    name="medication-text"
                    className="medication-text"
                    placeholder="Please specify your allergies"
                    rows={5}
                    value={
                      userDetails.medical_info
                        ? userDetails.medical_info.medication
                        : ""
                    }
                    onChange={(e) => {
                      setUserDetails({
                        ...userDetails,
                        medical_info: {
                          ...userDetails.medical_info,
                          medication: e.target.value,
                        },
                      });
                      //setMedication(e.target.value);
                    }}
                  />
                )}
            </AccordionItem>
          </div>
          <div className="btn-container">
            <button className="save-button" onClick={() => saveMedicalInfo()}>
              <img src={edit} alt="edit" />
              {t("profile.save_edits")}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
function mapStateToProps(state) {
  return { userData: state.auth.userData };
}

export default connect(mapStateToProps, {
  updateUserMedicalInfo,
})(withTranslation()(EditProfile));
